module.exports = __webpack_public_path__ + "static/media/leftArrowWhite.88f6b1a9.svg";